<template>
    <div class="field has-addons">
        <div class="control has-icons-left">
            <input v-model="mileage_num"
                   v-bind:class="{ 'is-danger': error && error.length > 0 }"
                   class="input"
                   type="number"
                   placeholder="Type Km's">
            <span class="icon is-small is-left">
                <i class="fas fa-cogs"></i>
            </span>
            <p v-if="error && error.length > 0" class="help is-danger">{{ error[0] }}</p>
        </div>
        <p class="control">
            <a class="button is-static">
                000
            </a>
        </p>
    </div>
</template>

<script>
    export default {
        computed: {
            mileage_num: {
                get: function () {
                    return this.$store.getters.getNewCarMileage
                },
                set: function (value) {
                    this.$store.dispatch('setNewCarMileage', value)
                }
            },
            error: {
                get: function () {
                    return this.$store.getters.getNewCarErrorMileage
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cars/Create/Inputs/MileageInput.vue